import React, {Component} from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import InnerWrap from '../../components/InnerWrap'
import MenuBtn from '../../components/MenuBtn'
import NavContent from '../../components/NavContent'
import Volume from "../Volume";
import {withUiContext} from "../../UiContext";

class VideoPage extends Component {
    state = {
        navContent: false,
    }

    toggleNav = (e) => {
        // const {navContent} = this.state
        // if (navContent) {
        // 	this.setState({navContent: false})
        // } else {
        // 	this.setState({navContent: true})
        // }
        this.setState((prevState) => ({navContent: !prevState.navContent}))
    }

    // handleVolumeChange = (volume) => {
    //     const { video, player } = this.props
    //     console.log('VideoPage this.props', this.props);
    //     if (video) video.volume = volume
    //     if (player) player.setVolume(volume);
    // }
    //
    // toggleVolume = () => {
    //     const { video, player } = this.props
    //     if (video) {
    //         video.volume > 0 ? video.volume = 0 : video.volume = 0.5
    //     }
    //     if (player) {
    //         player.getVolume().then((volume) => {
    //             if (volume > 0) {
    //                 player.setVolume(0)
    //             } else {
    //                 player.setVolume(0.5)
    //             }
    //         })
    //     }
    // }

    render() {
        const {navContent} = this.state
        const {children, background} = this.props

        let elements = React.Children.toArray(children)
        if (elements.length) {
            let lastElement = elements[elements.length - 1]
            elements =
                [React.cloneElement(elements[0], { ...this.state })]
                    .concat(elements.slice(1, -1))
                    .concat(React.cloneElement(lastElement))
        }

        return (
            <InnerWrap>
                <div className="hud__container-content">
                    <MenuBtn className={`animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}`} onClick={this.toggleNav} onMouseEnter={this.props.ui.playOverSound}/>

                    <TransitionGroup className="menu-outer">
                        {navContent &&
                            <CSSTransition timeout={300} classNames="menu-transition">
                                <NavContent onClose={this.toggleNav}/>
                            </CSSTransition>
                        }
                    </TransitionGroup>

                    {elements}
                </div>

                { false && (
                    <div className="hud__container-controls">
                        {!background && !navContent &&
                        <Volume onVolumeChange={this.handleVolumeChange} onToggleVolume={this.toggleVolume}/>
                        }

                        {/*CloseBtn*/}
                    </div>
                )}
            </InnerWrap>
        );
    }
}

export default withUiContext(VideoPage)
